export const progress = [
  {
    id: 1,
    icon: require("../../assets/People-progress.png"),
    number: "50",
    title: "Businesses Served",
  },
  {
    id: 2,
    icon: require("../../assets/Attach money-png.png"),
    number: "+500k",
    title: "Revenue Generated",
  },
  {
    id: 3,
    icon: require("../../assets/Happy-progress.png"),
    number: "%95",
    title: "Client Retention Rate",
  },
];
